import { gql } from "@outschool/ui-apollo";

export default gql`
  query ScheduleSuggestions(
    $uid: ID!
    $startAfter: DateTime
    $endAtDate: DateTime
    $startAfterTime: Int
    $endByTime: Int
    $dow: String
    $timeZone: String
    $limit: Int
  ) {
    activity(uid: $uid) {
      uid
      scheduleSuggestions(
        startAfter: $startAfter
        endAtDate: $endAtDate
        startAfterTime: $startAfterTime
        endByTime: $endByTime
        dow: $dow
        timeZone: $timeZone
        limit: $limit
      ) {
        startTime
        endTime
      }
    }
  }
`;
